module.exports = __webpack_public_path__ + "static/media/Crystal_Shooter_Full_Size.4402becc.jpg";